export class Loadpopup {
  _id: string;
  LoadNo: string;
  LoadDate: string;
  CustomerName: string;
  FromPlace: string;
  ToPlace: string;
}
